import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FacilityAlertItem } from '@weavix/models/src/alert/facility-alerts';

export * from '@weavix/models/src/alert/facility-alerts';

@Injectable({
    providedIn: 'root',
})
export class AlertMaydayService {
    private readonly alerts$: BehaviorSubject<FacilityAlertItem[]>;

    constructor() {
        this.alerts$ = new BehaviorSubject([]);
    }

    public get alerts(): Observable<FacilityAlertItem[]> {
        return this.alerts$.asObservable();
    }

    public setAlerts(values: FacilityAlertItem[]) {
        this.alerts$.next(values);
    }

    public addTempAlert(alerts: FacilityAlertItem[], newAlert: FacilityAlertItem): void {
        const updatedAlerts: FacilityAlertItem[] = [...alerts, newAlert];
        this.setAlerts(updatedAlerts);
    }

    public removeTempAlert(): void {
        this.setAlerts(this.alerts$.value.filter(alert => alert.id !== 'temporary'));
    }
}
